import React from 'react';
import { RootStack } from 'src/navigation/RootNavigation';
import LoginPage from './screens/Login';
const renderAuthRoutes = () => {
    return (React.createElement(RootStack.Group, null,
        React.createElement(RootStack.Screen, { name: "Login", component: LoginPage })));
};
export default renderAuthRoutes;
